import React from "react";
import { Form, Select, Checkbox } from "antd";

const Section8 = ({ formValues, setFormValues }) => (
  <Form layout="vertical">
    <Form.Item label="29. Preferred Method of Contact">
      <Select
        placeholder="Select"
        value={formValues.contactMethod}
        onChange={(val) => setFormValues({ ...formValues, contactMethod: val })}
      >
        <Select.Option value="Email">Email</Select.Option>
        <Select.Option value="Phone">Phone call or text</Select.Option>
      </Select>
    </Form.Item>

    <Form.Item label="30. Permission to share">
      <Checkbox
        checked={formValues.permission || false}
        onChange={(e) => setFormValues({ ...formValues, permission: e.target.checked })}
      >
        I give permission to share my business and contact information with matched agencies.
      </Checkbox>
    </Form.Item>
  </Form>
);

export default Section8;
